module.exports = __webpack_public_path__ + "static/media/community-gardens-fall.05b42ca6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/headers/community-gardens-fall.jpg
// module id = 620
// module chunks = 11